/**
 * HTTP Client Constants
 * Centralized constants for HTTP client configuration
 */

export const HTTP_METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  PATCH: "PATCH",
  DELETE: "DELETE",
} as const;

export const CONTENT_TYPES = {
  JSON: "application/json",
  TEXT: "text/plain",
  FORM_DATA: "multipart/form-data",
} as const;

export const DEFAULT_TIMEOUT = 30000;

// Carrier rating runs for minutes; must not abort before the backend's own 300s ceiling.
export const CARRIER_QUOTE_TIMEOUT = 300000;

export const API_VERSION_REGEX = /^api\/v\d+\//;
